// src/components/charts/IterationCountBar.jsx
//
// Bar chart of iteration_count distribution. Groups: 1, 2, 3, "non disponibile".
//
import React from 'react';
import {
  ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip,
} from 'recharts';

/**
 * Count rows by iteration_count: 1, 2, 3, null → "n/d".
 * Returns [{ bucket: '1', count: N }, ...]. Always 4 entries in fixed order.
 * Exported for unit testing.
 */
export function iterationBuckets(runs) {
  const buckets = [
    { bucket: '1', count: 0 },
    { bucket: '2', count: 0 },
    { bucket: '3', count: 0 },
    { bucket: 'n/d', count: 0 },
  ];
  if (!Array.isArray(runs)) return buckets;
  for (const r of runs) {
    const it = r?.iteration_count;
    if (it === 1) buckets[0].count += 1;
    else if (it === 2) buckets[1].count += 1;
    else if (it === 3) buckets[2].count += 1;
    else buckets[3].count += 1;
  }
  return buckets;
}

export default function IterationCountBar({ runs }) {
  const rows = iterationBuckets(runs);
  if (rows.every(r => r.count === 0)) return null;
  return (
    <ResponsiveContainer width="100%" height={200}>
      <BarChart data={rows} margin={{ top: 8, right: 16, bottom: 0, left: 0 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="rgba(0,0,0,0.06)" />
        <XAxis dataKey="bucket" tick={{ fontSize: 11, fill: '#6c6c6d' }} />
        <YAxis allowDecimals={false} tick={{ fontSize: 11, fill: '#6c6c6d' }} />
        <Tooltip contentStyle={{ fontSize: 12, fontFamily: "'DM Sans', sans-serif" }} />
        <Bar dataKey="count" fill="#1d1d1f" />
      </BarChart>
    </ResponsiveContainer>
  );
}
